(() => {

  const ICONS = {
    'save-tag' : `<svg width="25" height="25" viewBox="0 0 25 25" fill="none"><g><path d="M16.4616 10.7133C15.6805 11.4943 14.4142 11.4943 13.6331 10.7133C12.8521 9.93224 12.8521 8.66591 13.6331 7.88486C14.4142 7.10381 15.6805 7.10381 16.4616 7.88486C17.2426 8.66591 17.2426 9.93224 16.4616 10.7133Z" stroke="currentColor" stroke-width="1.5"/><path d="M9.63043 4.81655C10.4673 3.97963 11.6233 3.5453 12.7948 3.62756L16.7592 3.90588C18.7386 4.04485 20.3016 5.60785 20.4406 7.58731L20.7189 11.5516C20.8012 12.7232 20.3668 13.8791 19.5299 14.716L12.9646 21.2814C11.3812 22.8647 8.83135 22.882 7.26925 21.3199L3.02661 17.0772C1.46451 15.5151 1.48173 12.9652 3.06507 11.3819L9.63043 4.81655Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></g></svg>`,
    'gift' : `<svg width="25" height="25" viewBox="0 0 25 25" fill="none"><g><path d="M4.21899 11.1274H20.219M4.21899 11.1274C3.11443 11.1274 2.21899 10.232 2.21899 9.12744V8.12744C2.21899 7.02287 3.11442 6.12744 4.21899 6.12744H20.219C21.3236 6.12744 22.219 7.02287 22.219 8.12744V9.12744C22.219 10.232 21.3236 11.1274 20.219 11.1274M4.21899 11.1274L4.21899 20.1274C4.21899 21.232 5.11442 22.1274 6.21899 22.1274H18.219C19.3236 22.1274 20.219 21.232 20.219 20.1274V11.1274M12.219 6.12744H16.219C17.3236 6.12744 18.219 5.23201 18.219 4.12744C18.219 3.02287 17.3236 2.12744 16.219 2.12744C14.0099 2.12744 12.219 3.9183 12.219 6.12744ZM12.219 6.12744H8.21899C7.11442 6.12744 6.21899 5.23201 6.21899 4.12744C6.21899 3.02287 7.11442 2.12744 8.21899 2.12744C10.4281 2.12744 12.219 3.9183 12.219 6.12744ZM12.219 6.12744V22.1274" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g></svg>`,
    'pencil' : `<svg width="25" height="25" viewBox="0 0 25 25" fill="none"><g><path d="M14.6055 5.95858L18.388 9.74108M3.21899 21.1274L6.89177 20.4283C7.67052 20.28 8.38668 19.901 8.94723 19.3405L20.4027 7.88498C21.4911 6.79663 21.4911 5.03206 20.4027 3.9437C19.3144 2.85535 17.5498 2.85535 16.4615 3.94371L5.00595 15.3992C4.44541 15.9598 4.0664 16.6759 3.91815 17.4547L3.21899 21.1274Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g></svg>`,
    'coin' : `<svg viewBox="0 0 25 25" width="25" height="25" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12.5" cy="12.5" r="9.75" paint-order="markers stroke fill"/><path d="M10.25 15a2.25 2.25 0 1 0 4.5 0c0-1.243-1.247-1.921-2.25-2.5-1.076-.621-2.25-1.257-2.25-2.5a2.25 2.25 0 1 1 4.5 0m-2.25 7.5V19m0-13v1.5" paint-order="markers stroke fill" stroke-linecap="round"/></svg>`
  };

  (function(){
      var counter = 0;
      window.getSubscriptionWidgetFacadeId = function(){
          return 'jci-subscription-widget-facade-id-' + counter++
      }
  })();

  const ELEMENT_NODE = 1;

  const OPT_ONETIME = 'onetime';
  const OPT_SUBSCRIPTION = 'subscrp';

  const targetNode = document.body;
  const config = { attributes: false, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        initRCWidget(mutation.target);
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  function initRCWidget(target) {
    target.querySelectorAll('.rc-widget').forEach( widget => {
      if ( !widget.dataset.hasJciFacade ) {

        widget.dataset.hasJciFacade = "true";

        injectCSS();

        if (widget.matches('.rc_widget[data-widget]')) {
          widget.subscriptionWidgetFacade = {
            'onetime' : {},
            'subscription' : {}
          };

          let activeOptionValue;
          // TYPE 1 - AUTO-INJECTED RADIO
          widget.querySelectorAll('.rc-radio').forEach( rcOption => {
            widget.subscriptionWidgetFacade.getOptionType = (option) => {
              const input = option.querySelector('input[type=radio].rc-radio__input');
              if (input.checked) {
                activeOptionValue = input.value;
              }
              if (input.value == "onetime") {
                return OPT_ONETIME;
              } else if (input.value == "subsave") { 
                return OPT_SUBSCRIPTION;
              }
            }

            const price = rcOption.querySelector('.rc-option__price')?.textContent;
            const discount = rcOption.querySelector('.rc-option__discount')?.textContent;
            /*
            const input = rcOption.querySelector('input[type=radio].rc-radio__input');
            let optionType = "";
            if (input.value == "onetime") {
              optionType =  OPT_ONETIME;
            } else if (input.value == "subsave") { 
              optionType = OPT_SUBSCRIPTION;
            }
            */
            const optionType = widget.subscriptionWidgetFacade.getOptionType(rcOption);
            
            let frequency = '';
            if (optionType == OPT_ONETIME) {
              widget.subscriptionWidgetFacade.onetime = {
                'price': price,
              };
            } else {
              widget.subscriptionWidgetFacade.getFrequency = (option) => {
                const data = {
                  'sellingPlanId': null,
                  'frequency': {
                    'label': null,
                    'value': null,
                    'uom': null 
                  }
                };
                const select =  option.querySelector('.rc_widget__option__plans__dropdown');
                if (select) {
                  const sellingPlanId = select.value;
                  const optionEl = select.querySelector(`option[value="${ sellingPlanId }"`);
                  let freqLabel, freqValue, freqUOM;
                  [,,freqLabel,freqValue,freqUOM] = optionEl.dataset.planOption.match(/(Delivery every) (([0-9]*) (day|week)(s){0,1})/);
                  data.sellingPlanId = optionEl.value;
                  data.frequency.label = freqLabel;
                  data.frequency.value = freqValue;
                  data.frequency.uom = freqUOM;
                }
                return data;
              };

              widget.subscriptionWidgetFacade.getFrequencyList = (option) => {
                const select =  option.querySelector('.rc_widget__option__plans__dropdown');
                const frequencies = [];

                if (select) {
                  select.querySelectorAll('option').forEach( optionEl => {
                    let freqLabel, freqValue, freqUOM;
                    [,,freqLabel,freqValue,freqUOM] = optionEl.dataset.planOption.match(/(Delivery every) (([0-9]*) (day|week)(s){0,1})/);
                    frequencies.push({
                      'sellingPlanId': optionEl.value,
                      'frequency': {
                        'label': freqLabel,
                        'value': freqValue,
                        'uom': freqUOM
                      }
                    });
                  });
                }
                return frequencies;
              };

              widget.subscriptionWidgetFacade.subscription = widget.subscriptionWidgetFacade.getFrequency(rcOption); 
              widget.subscriptionWidgetFacade.subscription.options = widget.subscriptionWidgetFacade.getFrequencyList(rcOption);

            }

            observeRCOption(rcOption);
          });


          const onetimeRadioValue = 'onetime';
          const subscriptionRadioValue = 'subsave';

          const id = window.getSubscriptionWidgetFacadeId(); 
          const subInputId = id + '--subInput';
          const otInputId = id + '--subOutput';


          const productData = JSON.parse(widget.closest('form').querySelector('.jci-subscription-widget-facade-data').textContent);

          const subscriptionOptionLabel = fillPlaceholders(productData.subscription_option_label);
          const onetimeOptionLabel = fillPlaceholders(productData.onetime_option_label);

          let sellingPointsHTML = '';
          for (sellingPoint of productData.selling_points) {
            let iconHTML = '';
            if (sellingPoint.icon) {
              iconHTML = `<span class="subscription-widget-facade--icon"><img src="${ sellingPoint.icon }"></span>`;
            }

            const sellingPointText = fillPlaceholders(sellingPoint.text);
            const liHTML = `<li>${ iconHTML }${ sellingPointText }</li>`;

            sellingPointsHTML += liHTML;
          }

          const facadeHTML = `
<div class="subscription-widget-facade--label">Select Your Delivery</div>
<div class="subscription-widget-facade--options">
  <input class="subscription-widget-facade--option" id="${ subInputId }" type="radio" name="subscription-widget-facade" value="${ subscriptionRadioValue }" ${ subscriptionRadioValue == activeOptionValue ? 'checked' : '' }>
  <label class="subscription-widget-facade--option-label" for="${ subInputId }">
    <div class="subscription-widget-facade--option-header">
      <div class="subscription-widget-facade--option-title">${ subscriptionOptionLabel }</div>
      <div class="subscription-widget-facade--option-price" data-subscription-widget-facade-sub-price>${ widget.subscriptionWidgetFacade.subscription.price }</div>
    </div>
    <div class="subscription-widget-facade--option-content">
      <ul class="subscription-widget-facade--selling-points">
        ${ sellingPointsHTML }
      </ul>
      <div class="subscription-widget-facade--freq-option-label medium">Deliver Every</div>
      <div class="subscription-widget-facade--freq-option-selector-wrapper">
      <select class="subscription-widget-facade--freq-option-selector" data-subscription-widget-facade-frequency-selector>
        <option value="" selected disabled>Loading ...</option>
      </select>
        <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227252 0.852252C0.446922 0.632583 0.803078 0.632583 1.02275 0.852252L7.77275 7.60225C7.99242 7.82192 7.99242 8.17808 7.77275 8.39775L1.02275 15.1477C0.803078 15.3674 0.446922 15.3674 0.227252 15.1477C0.00758251 14.9281 0.00758251 14.5719 0.227252 14.3523L6.5795 8L0.227252 1.64775C0.00758251 1.42808 0.00758251 1.07192 0.227252 0.852252Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
  </label>

  <input class="subscription-widget-facade--option" id="${ otInputId }" type="radio" name="subscription-widget-facade" value="${ onetimeRadioValue }"  ${ onetimeRadioValue == activeOptionValue ? 'checked' : '' }>
  <label class="subscription-widget-facade--option-label onetime" for="${ otInputId }">
    <div class="subscription-widget-facade--option-header">
      <div class="subscription-widget-facade--option-title">${ onetimeOptionLabel } </div>
      <div class="subscription-widget-facade--option-price" data-subscription-widget-facade-ot-price>${ widget.subscriptionWidgetFacade.onetime.price }</div>
    </div>
  </label>
</div>`;
          facade = document.createElement("div");
          facade.id = id;
          facade.classList.add('subscription-widget-facade');
          facade.insertAdjacentHTML('afterbegin', facadeHTML );
          widget.insertAdjacentElement('afterend', facade);

          widget.subscriptionWidgetFacade.facade = facade;

          facade.querySelectorAll('select[data-subscription-widget-facade-frequency-selector]').forEach( select => {
            select.addEventListener('change', e => {
              const rcSelect =  widget.querySelector('.rc_widget__option__plans__dropdown');
              rcSelect.value = select.value;
              rcSelect.dispatchEvent(new Event('change'));
            });
          });

          facade.querySelectorAll('.subscription-widget-facade--option').forEach( radio => {
            radio.addEventListener('change', e => {
              const input = widget.querySelector(`input[value="${ radio.value }"]`);
              input.dispatchEvent(new MouseEvent('click'));
            });
          });

          widget.style.display = 'none';
        }
      }
    });
  }

  function fillPlaceholders(text) {
    let output = text;
    output = output.replaceAll('::save-tag::',`<span class="subscription-widget-facade--icon">${ ICONS['save-tag'] }</span>`);
    output = output.replaceAll('::gift::',`<span class="subscription-widget-facade--icon">${ ICONS['gift'] }</span>`);
    output = output.replaceAll('::pencil::',`<span class="subscription-widget-facade--icon">${ ICONS['pencil'] }</span>`);
    output = output.replaceAll('::coin::',`<span class="subscription-widget-facade--icon">${ ICONS['coin'] }</span>`);
    output = output.replaceAll('${annual_savings}',`<span data-subscription-widget-facade-sub-price-annual-savings></span>`);
    output = output.replaceAll('${savings}',`<span data-subscription-widget-facade-sub-price-savings>$0</span>`);
    output = output.replaceAll('${discount}',`<span data-subscription-widget-facade-sub-discount>0%</span>`);
    return output;
  }

  function updateFacadeOneTimePrice(widget, price) {
    widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-ot-price]').forEach( el => {
      el.textContent = price;
    });
    widget.subscriptionWidgetFacade.onetime.price = price;
  }
  function updateFacadeSubscriptionPrice(widget, price) {
    widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-sub-price]').forEach( el => {
      el.textContent = price;
    });
    widget.subscriptionWidgetFacade.subscription.price = price;
  }
  function updateFacadeSubscriptionDiscount(widget, discount) {
    widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-sub-discount]').forEach( el => {
      el.textContent = discount;
    });
    widget.subscriptionWidgetFacade.subscription.discount = discount;
  }
  function updateFacadeSubscriptionPriceSavings(widget) {
    if (widget.subscriptionWidgetFacade.onetime.price && widget.subscriptionWidgetFacade.subscription.price ) {
      const priceFloat = parseFloat(widget.subscriptionWidgetFacade.subscription.price.replaceAll(',','').match(/^\$?(\d+(\.\d{2})?)$/)[1]);
      const otPriceFloat = parseFloat(widget.subscriptionWidgetFacade.onetime.price.replaceAll(',','').match(/^\$?(\d+(\.\d{2})?)$/)[1]);
      //const savings = '$' + parseFloat((otPriceFloat - priceFloat).toFixed(2).replace(/\.?0+$/, '')).toLocaleString('en-US');
     
      const savings = (otPriceFloat - priceFloat).toFixed(2);
      widget.subscriptionWidgetFacade.subscription.savingsPrice = savings;

      const savingsStr = '$' + (otPriceFloat - priceFloat).toFixed(2).toLocaleString('en-US');

      widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-sub-price-savings]').forEach( el => {
        el.textContent = savingsStr;
      });
    }
  }
  function updateFacadeSubscriptionPriceSavings(widget) {
    if (widget.subscriptionWidgetFacade.onetime.price && widget.subscriptionWidgetFacade.subscription.price ) {
      const priceFloat = parseFloat(widget.subscriptionWidgetFacade.subscription.price.replaceAll(',','').match(/^\$?(\d+(\.\d{2})?)$/)[1]);
      const otPriceFloat = parseFloat(widget.subscriptionWidgetFacade.onetime.price.replaceAll(',','').match(/^\$?(\d+(\.\d{2})?)$/)[1]);
      //const savings = '$' + parseFloat((otPriceFloat - priceFloat).toFixed(2).replace(/\.?0+$/, '')).toLocaleString('en-US');
     
      const savings = (otPriceFloat - priceFloat).toFixed(2);
      widget.subscriptionWidgetFacade.subscription.savingsPrice = savings;

      const savingsStr = '$' + (otPriceFloat - priceFloat).toFixed(2).toLocaleString('en-US');

      widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-sub-price-savings]').forEach( el => {
        el.textContent = savingsStr;
      });
      widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-sub-price-savings-pct]').forEach( el => {
        el.textContent = savingsStr;
      });
    }
  }

  function updateFacadeSubscriptionFrequency(widget, option) {
    const frequency = widget.subscriptionWidgetFacade.getFrequency(option);
    widget.subscriptionWidgetFacade.subscription.sellingPlanId = frequency.sellingPlanId;
    widget.subscriptionWidgetFacade.subscription.frequency = frequency.frequency;
    widget.subscriptionWidgetFacade.facade.querySelectorAll('select[data-subscription-widget-facade-frequency-selector]').forEach( el => {
      el.value = frequency.sellingPlanId;
    });
  }

  function updateFacadeSubscriptionFrequencies(widget, option) {
    const frequencies = widget.subscriptionWidgetFacade.getFrequencyList(option);
    widget.subscriptionWidgetFacade.subscription.frequencies = frequencies;

    widget.subscriptionWidgetFacade.facade.querySelectorAll('select[data-subscription-widget-facade-frequency-selector]').forEach( el => {
      for (const frequency of frequencies) {
        let freqOption = el.querySelector(`[value="${ frequency.sellingPlanId }"]`);
        if (!freqOption) {
          el.insertAdjacentHTML('beforeend', `<option value="${ frequency.sellingPlanId }">${ frequency.frequency.label }</option>`);
        }
      }
    });
  }

  function updateFacadeSubscriptionPriceAnnualSavings(widget) {
    if (widget.subscriptionWidgetFacade.onetime.price && widget.subscriptionWidgetFacade.subscription.price ) {
      const frequency = widget.subscriptionWidgetFacade.subscription.frequency;
      //const frequencies = widget.subscriptionWidgetFacade.getFrequencyList(option);

      let annualSavingsStr = '';
      if (frequency.uom == 'day') {
        const annualSavings = (365.0 / frequency.value ) * widget.subscriptionWidgetFacade.subscription.savingsPrice;
        annualSavingsStr = '$' + annualSavings.toFixed(2).toLocaleString('en-US');
      }

      widget.subscriptionWidgetFacade.facade.querySelectorAll('[data-subscription-widget-facade-sub-price-annual-savings]').forEach( el => {
        el.textContent = annualSavingsStr;
      });
    }
  }

  function observeRCOption(option) {

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const price = option.querySelector('.rc-option__price')?.textContent;
          const discount = option.querySelector('.rc-option__discount')?.textContent;
          const widget = option.closest('[data-has-jci-facade]');
          const optionType = widget.subscriptionWidgetFacade.getOptionType(option);
          const facade = widget.subscriptionWidgetFacade.facade;

          if (optionType == OPT_ONETIME) {

            // Price
            updateFacadeOneTimePrice(widget, price);
            updateFacadeSubscriptionPriceSavings(widget);
            updateFacadeSubscriptionPriceAnnualSavings(widget);

          } else if (optionType == OPT_SUBSCRIPTION) {

            // Price
            updateFacadeSubscriptionPrice(widget, price);
            updateFacadeSubscriptionDiscount(widget, discount);
            updateFacadeSubscriptionPriceSavings(widget);
            updateFacadeSubscriptionFrequencies(widget, option);
            updateFacadeSubscriptionFrequency(widget, option);
            updateFacadeSubscriptionPriceAnnualSavings(widget);

          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(option, {
      attributes: false,
      childList: true,
      subtree: true
    });

  }

  function injectCSS() {
    if (!document.getElementById('subscription-widget-facade-css')) { 
      const facadeStyle = ` 
<style id="subscription-widget-facade-css">
  .subscription-widget-facade {
    font-size: var(--subscription-widget-facade-font-scale, 123%);
  }
  .subscription-widget-facade--label {
    font-weight: 500;
  }
  .subscription-widget-facade--options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 6px;
  }
  .subscription-widget-facade--option { display: none; }
  .subscription-widget-facade--option-label { 
    border: 1px solid #1e1e1f;
    padding: 0;
    border-radius: 5px;
    box-shadow: 0 0 6px rgba(0,0,0,0.2);
    position: relative;
  }
  .subscription-widget-facade--option-label:first-of-type::after {
    content: 'Most popular';
    display: block;
    position: absolute;
    top: 0;
    right: 12px;
    border-radius: 6px;
    background-color: black;
    color: white;
    font-size: 75.05%;
    font-weight: 500;
    padding: 0 8px;
    transform: translateY(-60%);
  }
  .subscription-widget-facade--option-header {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px 8px 5px;
    position: relative;
    outline: 1px solid #1e1e1f;
    cursor: pointer;
    font-weight: 500;
    border-radius: 4px 4px 0 0;
  }

  .subscription-widget-facade--option-label.onetime .subscription-widget-facade--option-header {
    border-radius: 4px;
  }
  .subscription-widget-facade--option-header:before { 
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256' %3E%3Cg%3E%3Cg%3E%3Cpath fill='%23000000' d='M128,10C62.9,10,10,62.9,10,128c0,65.1,52.9,118,118,118c65.1,0,118-52.9,118-118C246,62.9,193.1,10,128,10z M128,229.1c-55.7,0-101.1-45.3-101.1-101.1S72.3,26.9,128,26.9S229.1,72.3,229.1,128S183.7,229.1,128,229.1z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    width: 16px;
    height: 16px;
    position: absolute;
    left: 10px;
    top: 0;
    bottom: 0;
    margin: auto; 
  }
  .subscription-widget-facade--option:checked + label { 
  }
  .subscription-widget-facade--option:checked + label .subscription-widget-facade--option-header:before { 
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256' %3E%3Cg%3E%3Cg%3E%3Cpath fill='%23000000' d='M128,10C62.9,10,10,62.9,10,128c0,65.1,52.9,118,118,118c65.1,0,118-52.9,118-118C246,62.9,193.1,10,128,10z M128,229.1c-55.7,0-101.1-45.3-101.1-101.1S72.3,26.9,128,26.9S229.1,72.3,229.1,128S183.7,229.1,128,229.1z'%3E%3C/path%3E%3Cpath fill='%23000000' d='M128,85.7c-23.3,0-42.3,19-42.3,42.3c0,23.3,19,42.3,42.3,42.3c23.3,0,42.3-19,42.3-42.3C170.3,104.7,151.3,85.7,128,85.7z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
  .subscription-widget-facade--option:checked + label .subscription-widget-facade--option-header { 
    background-color: var(--subscription-widget-facade--selected-bg, #EFE9E4);
    color: var(--subscription-widget-facade--selected-fg, inherit);
    font-weight: 500;
  }
  .subscription-widget-facade--option-title {
    margin-left: 32px;
    font-weight: 500;
  }
  .subscription-widget-facade--option-content {
    padding: 12px 24px 16px;
  }
  .subscription-widget-facade--option-content > :first-child {
    margin-top: 0 !important;
  }
  .subscription-widget-facade--selling-points {
    padding-left: 0;
    list-style: none;
  }
  .subscription-widget-facade--freq-option-label {
  }
  .subscription-widget-facade--freq-option-selector-wrapper {
    width: 100%;
    border: 1px solid #1e1e1f;
    border-radius: 5px;
    overflow: hidden;
    display: grid;
    position: relative;
    box-shadow: 0 0 6px rgba(0,0,0,.2);
  }
  .subscription-widget-facade--freq-option-selector-wrapper svg {
    position: absolute;
    width: 6px;
    bottom: 0;
    height: auto;
    transform: rotate(90deg) translatex(1px);
    margin: auto;
    top: 0;
    right: 10px;
  }
  .subscription-widget-facade--freq-option-selector {
    appearance: none;
    background-color: transparent;
    border: 0;
    padding: 5px 24px 5px 8px;

    font-size: var(--subscription-widget-facade-font-scale, 100%);
    font-family: inherit;
  }
  .subscription-widget-facade--freq-option-selector > option[value=""] {
    display: none;  
  }
  .subscription-widget-facade--icon {
    height: 1.33em;
    width: 1.33em;
    display: inline-block;
    vertical-align: middle;
    margin-right: .33em;
    position: relative;
  }
  .subscription-widget-facade--icon img,
  .subscription-widget-facade--icon svg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .subscription-widget-facade--icon {
  }
  .subscription-widget-facade + * svg.reload-icon {
    padding: 2px 0 0;
    margin-bottom: -2px;
    margin-left: 3px;
  }
}
</style>`;
      document.head.insertAdjacentHTML('beforeend', facadeStyle );
    }
  }
})();
